import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PDFObject from 'pdfobject';

const LeftSection = ({ publicationId, publicationData, loadingPublication }) => {
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const pdfUrl = publicationData?.url || "";

  // Function to navigate to upload page
  const handleUploadClick = () => {
    navigate('/uploadfile');
  };

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    if (!pdfUrl) {
      containerRef.current.innerHTML = "";
      return;
    }

    if (pdfUrl.includes('drive.google.com')) {
      // Render iframe directly for Drive URLs
      containerRef.current.innerHTML = `<iframe src="${pdfUrl}" width="100%" height="100%" style="border: none;"></iframe>`;
    } else {
      PDFObject.embed(pdfUrl, containerRef.current, {
        pdfOpenParams: {
          toolbar: '1',
          view: 'Fit',
        },
        height: '100%',
        width: '100%',
      });
    }
  }, [pdfUrl]);

  return (
    <div style={styles.pageContainer}>
      <div style={styles.breadcrumbContainer}>
        <span style={styles.breadcrumbMain}>PubVision AI</span>
        <span style={styles.breadcrumbSeparator}> &gt; </span>
        <span
          style={styles.breadcrumbItem}
          onClick={handleUploadClick}
        >
          Upload
        </span>
        <span style={styles.breadcrumbSeparator}> &gt; </span>
        <span style={styles.breadcrumbItem}>Publication View</span>
      </div>

      <div style={styles.container}>
        {loadingPublication && <div>Loading PDF...</div>}
        {!loadingPublication && !pdfUrl && <div>Publication not found.</div>}
        <div ref={containerRef} style={{ width: '100%', height: '100%', display: (!loadingPublication && pdfUrl) ? 'block' : 'none' }}></div>
      </div>
    </div>
  );
};

const styles = {
  pageContainer: {
    display: "flex",
    flexDirection: "column",
    width: "45%",
    padding: "20px",
    boxSizing: "border-box",
    height: "100%",
    overflowY: "auto"
  },
  breadcrumbContainer: {
    marginBottom: "10px",
  },
  breadcrumbMain: {
    fontWeight: "bold",
    color: "#000",
  },
  breadcrumbSeparator: {
    margin: "0 5px",
    color: "#888",
  },
  breadcrumbItem: {
    color: "#888",
    cursor: "pointer",
  },
  container: {
    width: "100%",
    padding: "20px",
    backgroundColor: "#fff",
    aspectRatio: "1 / 1.414",
    boxSizing: "border-box",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    position: "relative",
    overflow: "hidden",
  },
};

export default LeftSection;